export const queryKeys = {
  subscription: (userId: string | null | undefined) => ['subscription', userId ?? null] as const,
  buildCredits: (userId: string | null | undefined) => ['build-credits', userId ?? null] as const,
  conversations: (userId: string | null | undefined) => ['conversations', userId ?? null] as const,
  messages: (conversationId: string | null | undefined) => ['messages', conversationId ?? null] as const,
};
